import type { MessageKey } from '../i18n/t';

export interface GridNavAction {
  labelKey: MessageKey; // i18n key for the menu item
  to: (row: Record<string, unknown>) => string; // target URL built from the row
}

// resourceCode → nav actions shown in that grid's context menu.
// Central, extensible map: future grids add entries here (no component change).
export const gridNavRegistry: Record<string, GridNavAction[]> = {
  assets: [
    { labelKey: 'contextMenu.openAssetForm', to: (r) => `/asset-form?id=${r.assetId}` },
  ],
  funds: [
    { labelKey: 'contextMenu.openFundForm', to: (r) => `/fund-form?id=${r.fundId}` },
  ],
};

export function navActionsFor(resourceCode: string): GridNavAction[] {
  return gridNavRegistry[resourceCode] ?? [];
}
